import  { useEffect, useState } from 'react';
import SignInCarosel from '../employer/signInCarousel';
import { Button } from '@mui/material';
import { ReactComponent as LoginBack } from '../../assets/images/left-nav.svg';
import { useNavigate } from 'react-router-dom';
import './style.scss'
// JOB SEEKER BANNER FUNCTION 
const JobSeekerBanner = () => {
  const navigate = useNavigate();
  const [locationValue, setLocationValue] = useState('');

  // GOBACK FUNCTION 
  const handleGoBack = () => {
    navigate(-1);
  };
  useEffect(() => {
    const locationIp = async () => {
      try {
        const response = await fetch('https://ipapi.co/json/');
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        setLocationValue(data?.city);
      } catch (error) {
        console.log('location_error', error);
      }
    };

    locationIp();
  }, []);

  return (
    <div className="SinginFormLeft" style={{ backgroundColor: '#fff' }}>
      <Button className='loginBackBtn' onClick={handleGoBack}>
        <LoginBack />
        <span>Back</span>
      </Button>
      <img src={require('../../assets/images/jobseek.jpg')} className="SinginFormBgImg" alt="" style={{ padding: '50px 120px' }} />
      <div className="SinginFormCarouselContainer" style={{ top: 0, paddingBottom: '30px' }}>
        <div className="SinginFormCarouselTitle">
          Join over 15,000+ <br />
          Part Timers around {locationValue}
        </div>
        <SignInCarosel />
      </div>
    </div>
  );
}

export default JobSeekerBanner;